'use strict';

module.exports = {
    getTranslation: function (key) {
        let translations = window.jsTranslations;

        return translations[key] || key;
    }
};
